import { render, staticRenderFns } from "./Ezship.vue?vue&type=template&id=0296c1e9&scoped=true&"
import script from "./Ezship.vue?vue&type=script&lang=js&"
export * from "./Ezship.vue?vue&type=script&lang=js&"
import style0 from "./Ezship.vue?vue&type=style&index=0&id=0296c1e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296c1e9",
  null
  
)

export default component.exports